/* LRC Header 4 (Encore): adds a search bar to the top of the phone menu and a clearer search placeholder. */
(function () {
  var PLACEHOLDER = 'Search tees, sizes, patterns';
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function init() {
    var content = document.querySelector('.main-menu__content');
    if (content && !content.querySelector('.lrc-menu-search')) {
      var wrap = document.createElement('div');
      wrap.className = 'lrc-menu-search';
      var form = document.createElement('form');
      form.action = root() + 'search';
      form.method = 'get';
      form.setAttribute('role', 'search');
      var input = document.createElement('input');
      input.type = 'search';
      input.name = 'q';
      input.placeholder = PLACEHOLDER;
      input.setAttribute('aria-label', 'Search');
      var btn = document.createElement('button');
      btn.type = 'submit';
      btn.setAttribute('aria-label', 'Search');
      btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path></svg>';
      form.appendChild(input);
      form.appendChild(btn);
      wrap.appendChild(form);
      content.insertBefore(wrap, content.firstChild);
    }
    document.querySelectorAll('.header input[type="search"]').forEach(function (i) { i.placeholder = PLACEHOLDER; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Quick buy pop-up ("Choose options" on product cards): adds a size guide and a clear link to the full product page,
   and keeps shoppers on the collection page after they add, so they can add more sizes or products. */
(function () {
  var dlg;
  function guideDialog() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'lrc-qa-guide';
    dlg.setAttribute('aria-label', 'Size guide');
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('.lrcp-guide-x')) { dlg.close(); return; }
      var tab = e.target.closest('[data-tab]');
      if (tab) {
        dlg.querySelectorAll('[data-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        dlg.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.dataset.panel !== tab.dataset.tab; });
      }
    });
    document.body.appendChild(dlg);
    return dlg;
  }
  function enhance(drawer) {
    var box = drawer.querySelector('.js-product-details');
    if (!box || box.querySelector('.lrc-qa-help') || !box.querySelector('.product-options')) return;
    var url = drawer.productUrl || '';
    var guide = drawer.productEl && drawer.productEl.querySelector('.lrcp-guide-in');
    var help = document.createElement('div');
    help.className = 'lrc-qa-help';
    if (guide) {
      var g = document.createElement('button');
      g.type = 'button'; g.className = 'lrc-qa-link'; g.textContent = 'Size guide';
      var html = guide.innerHTML;
      g.addEventListener('click', function () { var d = guideDialog(); d.innerHTML = '<div class="lrcp-guide-in">' + html + '</div>'; d.showModal(); });
      help.appendChild(g);
    }
    var a = document.createElement('a');
    a.className = 'lrc-qa-link js-prod-link'; a.href = url; a.textContent = 'View full details';
    help.appendChild(a);
    var opts = box.querySelector('.product-options');
    opts.parentNode.insertBefore(help, opts);
    var note = drawer.querySelector('.js-added-to-cart');
    if (note) note.dataset.visibleFor = '3000';
    /* Free shipping progress sits right above Add to cart so shoppers see it as they add. */
    var footer = drawer.querySelector('.quick-add__footer');
    var form = footer && footer.querySelector('product-form');
    if (form && !footer.querySelector('.lrc-qa-ship')) {
      var ship = document.createElement('div');
      ship.className = 'lrc-qa-ship';
      footer.insertBefore(ship, form);
    }
    if (lastCart) showShip(lastCart); else refreshShip();
  }
  /* Free shipping line: orders of $99 or more ship free in the contiguous US, everything else is a flat $6.99. */
  var FREE_AT = 9900, FLAT = '$6.99', lastCart = null;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function showShip(cart) {
    lastCart = cart;
    var total = cart.total_price || 0;
    var left = FREE_AT - total;
    var pct = Math.max(0, Math.min(100, Math.round(total / FREE_AT * 100)));
    var msg = total <= 0
      ? '<b>Free shipping on orders of $99 or more.</b> Orders under $99 ship for a flat ' + FLAT + '.'
      : left > 0
        ? '<b>Your cart is ' + money(total) + '. Add ' + money(left) + ' more for free shipping.</b> Orders under $99 ship for a flat ' + FLAT + '.'
        : '<b>Your cart ships free!</b> (Contiguous US)';
    document.querySelectorAll('.lrc-qa-ship').forEach(function (el) {
      el.innerHTML = '<p>' + msg + '</p><div class="lrc-qa-bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div>';
    });
  }
  function refreshShip() {
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js')
      .then(function (r) { return r.json(); }).then(showShip).catch(function () {});
  }
  ['on:cart:add', 'on:line-item:change'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (e.detail && e.detail.cart) showShip(e.detail.cart); else refreshShip(); });
  });
  function init() {
    var drawer = document.querySelector('quick-add-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var box = drawer.querySelector('.js-product-details');
    if (!box) return;
    new MutationObserver(function () { enhance(drawer); }).observe(box, { childList: true });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.js-quick-add')) refreshShip(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Cart drawer: hide the discount code box an app adds there. Shoppers enter codes at checkout instead. */
(function () {
  var queued = false;
  function hide() {
    queued = false;
    document.querySelectorAll('.drawer--cart input').forEach(function (i) {
      var label = (i.placeholder || '') + ' ' + (i.getAttribute('aria-label') || '') + ' ' + (i.name || '');
      if (!/discount|coupon|promo/i.test(label)) return;
      var el = i;
      while (el.parentElement && !el.parentElement.matches('.cart-drawer__checkout-buttons, .cart-drawer__summary, .drawer--cart') &&
             !el.parentElement.querySelector('[name="checkout"], .lrcg')) el = el.parentElement;
      el.style.display = 'none';
    });
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(hide); } }
  function init() {
    var d = document.querySelector('.drawer--cart');
    if (!d) return;
    hide();
    if ('MutationObserver' in window) new MutationObserver(queue).observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
